import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";

import {IntlProvider} from 'react-intl';

import messages_en from './translations/en.json';
import messages_ptBr from './translations/ptBr';
import messages_es from './translations/es.json';


{/*ReactDOM.render(<App />, document.getElementById('root'));*/}

const messages ={
    'en': messages_en,
    'pt-br': messages_ptBr,
    'es': messages_es
};

const language = navigator.language.split(/[-]/)[0];

ReactDOM.render((

    <IntlProvider locale={language} messages={messages[language]}>
    <BrowserRouter>
                <App/>
    </BrowserRouter> </IntlProvider>
), document.getElementById('root'));


